import type { ModalConfig } from '../types/form';

const defaultConfig: ModalConfig = {
    thankYou_notEmail: {
        type: 'dsa_modal',
        header: 'Dziękujemy za zgłoszenie',
        text: 'Komentarz został zgłoszony do moderacji.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ],
    },
    thankYou_haveEmail: {
        type: 'dsa_modal',
        header: 'Dziękujemy za zgłoszenie',
        text: 'Komentarz został zgłoszony do moderacji.',
        extraText: 'Aby otrzymać informację o statusie zgłoszenia oraz sposobie jego rozpatrzenia, potwierdź zgłoszenie i adres e-mail, klikając w link przesłany w wiadomości.',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    already_submit: {
        type: 'dsa_modal',
        header: 'Komentarz został już wcześniej zgłoszony do moderacji',
        text: '',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    confirm_mail: {
        type: 'dsa_modal',
        header: 'Zgłoszenie i adres e-mail potwierdzone',
        text: 'Otrzymasz informację o statusie zgłoszenia oraz sposobie jego rozpatrzenia.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    already_confirmed: {
        type: 'dsa_modal',
        header: 'Zgłoszenie i adres e-mail zostały już potwierdzone',
        text: 'Otrzymasz informację o statusie zgłoszenia oraz sposobie jego rozpatrzenia.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    link_expired: {
        type: 'dsa_modal',
        header: 'Link wygasł',
        text: 'Czas na potwierdzenie adresu e-mail wynosi 7 dni.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    something_wrong: {
        type: 'dsa_modal',
        header: 'Coś poszło nie tak',
        text: '',
        extraText: '',
        extraClass: 'dsaModal--error',
        buttons: [
            {
                text: 'Spróbuj ponownie',
                action: 'RESUBMIT_FORM'
            },
        ]
    },
    complaint_something_wrong: {
        type: 'dsa_modal',
        header: 'Coś poszło nie tak',
        text: '',
        extraText: '',
        extraClass: 'dsaModal--error',
        buttons: [{ text: 'Spróbuj ponownie', action: 'RESUBMIT_COMPLAINT' }]
    },
    something_wrong_mail: {
        type: 'dsa_modal',
        header: 'Coś poszło nie tak',
        text: '',
        extraText: '',
        extraClass: 'dsaModal--error',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    complaint_form: {
        type: 'dsa_modal',
        header: 'Odwołanie',
        text: 'Aby odwołać się od decyzji dotyczącej zgłoszonych przez Ciebie treści lub treści usuniętych, których jesteś autorem uzupełnij poniższy formularz w terminie nie dłuższym niż 14 dni od powiadomienia o decyzji.',
        extraText: '',
        extraClass: '',
        inputs: [
            {
                type: 'textarea',
                name: 'complaint_reason',
                placeholderText: 'Napisz tutaj',
                label: 'Powody dla których uważasz, że decyzja jest niesłuszna i powinna zostać zmieniona',
                required: true,
                actionType: 'input',
                actionMethod: 'checkText',
                helperText: '',
                extraCss: 'dsaModal__input--textarea',
            }
        ],
        buttons: [
            {
                text: 'Anuluj',
                action: 'CLOSE'
            },
            {
                text: 'Wyślij',
                action: 'SEND_COMPLAINT'
            },
        ]
    },
    complaint_expired: {
        type: 'dsa_modal',
        header: 'Czas na wniesienie odwołania upłynął',
        text: 'Odwołanie wnosi się w terminie 14 dni od momentu powiadomienia.',
        extraText: '',
        extraClass: '',
        buttons: [{ text: 'Wróć do artykułu', action: 'BACK' }],
    },
    complaint_thankYou: {
        type: 'dsa_modal',
        header: 'Dziękujemy',
        text: 'Twoje odwołanie już do nas dotarło.',
        extraText: '',
        extraClass: '',
        buttons: [{ text: 'Wróć do artykułu', action: 'BACK' }],
    },
    complaint_confirmed: {
        type: 'dsa_modal',
        header: 'Odwołanie zostało już zgłoszone',
        text: 'Otrzymasz informację po rozpatrzeniu odwołania.',
        extraText: '',
        extraClass: '',
        buttons: [{ text: 'Wróć do artykułu', action: 'BACK' }],
    },
    bulk_background_process: {
        type: 'dsa_modal',
        header: 'Proces uruchomiony w tle',
        text: 'Usunięcie będzie obejmowało paczkę do 50 tys. postów w zaznaczonym okresie.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Rozumiem',
                action: 'BACK'
            },
        ]
    },
    bulk_deleting_in_progress: {
        type: 'dsa_modal',
        header: 'Proszę czekać',
        text: 'Komentarze autora są w trakcie usuwania',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Rozumiem',
                action: 'BACK'
            },
        ]
    },
    bulk_delete_error: {
        type: 'dsa_modal',
        header: 'Wystąpił błąd',
        text: 'Proces usuwania nie powiódł się. Spróbuj ponownie później.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Rozumiem',
                action: 'BACK'
            },
        ]
    },
    delete_form: {
        type: 'form',
        header: 'Usuń',
        text: '',
        extraText: '',
        extraClass: '',
        inputs: [
            {
                type: 'select',
                name: 'reason',
                label: 'Powód usunięcia',
                placeholderText: 'Wybierz powód usunięcia',
                required: true,
                actionType: '',
                actionMethod: '',
                helperText: '',
                extraCss: '',
                options: [
                    { name: "Komercyjny charakter", value: "commercial_nature" },
                    { name: "Wulgaryzmy", value: "profanity" },
                    { name: "Sprzeczność z dobrymi obyczajami", value: "contradiction_with_good_manners" },
                    { name: "Podszywanie się", value: "impersonation" },
                    { name: "Dezinformacja", value: "disinformation" },
                    { name: "Kopia komentarza", value: "copy_of_comment" },
                    { name: "Dyskryminacja", value: "discrimination" },
                    { name: "Ataki personalne na rozmówców", value: "personal_attacks_on_interlocutors" },
                    { name: "Brak treści", value: "no_content" },
                    { name: "Pisanie pod wieloma loginami", value: "writing_under_multiple_logins" },
                    { name: "Pozycjonowanie", value: "positioning" },
                    { name: "Spam", value: "spam" },
                    { name: "Naruszenie dóbr osobistych", value: "infringement_of_personal_rights" },
                    { name: "Pomówienie", value: "slander" },
                    { name: "Znieważenie", value: "insult" },
                    { name: "Groźby", value: "threats" },
                    { name: "Mowa nienawiści", value: "hate_speech" },
                    { name: "Naruszenie praw autorskich", value: "copyright_infringement" },
                    { name: "Nawoływanie lub pochwalanie przestępstwa", value: "incitement_or_praise_for_crime" },
                    { name: "Propagowanie totalitaryzmu", value: "promoting_totalitarianism" },
                    { name: "Uporczywe nękanie/stalking", value: "persistent_stalking" },
                    { name: "Inne", value: "others" },
                ],
            },
            {
                type: 'textarea',
                name: 'explain',
                label: 'Wpisz powód usunięcia',
                placeholderText: '',
                required: false,
                actionType: '',
                actionMethod: '',
                helperText: '',
                extraCss: '',
            },
            {
                type: 'text',
                name: 'base',
                label: 'Podstawa decyzji',
                placeholderText: 'Wybierz podstawę decyzji',
                required: true,
                actionType: '',
                actionMethod: '',
                helperText: 'Wybierz podstawę.',
                extraCss: '',
            },
        ],
        buttons: [
            {
                text: 'Anuluj',
                action: 'CLOSE'
            },
            {
                text: 'Wyślij',
                action: 'DELETE_ACTION'
            },
        ]
    },
    birthday_form: {
        type: 'dsa_modal',
        header: 'Podaj datę urodzenia',
        text: 'Aby wziąć udział w dyskusji, potwierdź, że masz ukończone 16 lat.',
        extraText: '',
        extraClass: '',
        inputs: [
            {
                type: 'date',
                name: 'birthday',
                value: '',
                placeholderText: '',
                label: '',
                required: false,
                actionType: 'input',
                actionMethod: 'UPDATE_BIRTHDAY',
                helperText: '',
                extraCss: 'dsaModal__input--birthday',
            }
        ],
        buttons: [
            {
                text: 'Zapisz',
                action: 'SEND_NEW_BIRTHDAY_DATE'
            },
        ]
    },
    birthday_thankYou: {
        type: 'dsa_modal',
        header: 'Dziękujemy',
        text: 'Twoja data została zapisana',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    complete_activation: {
        type: 'dsa_modal',
        header: 'Dokończ aktywację konta',
        text: 'Aby wziąć udział w dyskusji, dokończ aktywację konta. Sprawdź swoją skrzynkę e-mail.',
        extraText: '',
        required: true,
        extraClass: '',
        buttons: [
            {
                text: 'Anuluj',
                action: 'CLOSE'
            },
            {
                text: 'Wyślij ponownie',
                action: 'SEND_ACTIVATION_EMAIL_AGAIN'
            },
        ]
    },
    restore_action: {
        type: 'dsa_modal',
        header: 'Przywróć',
        text: 'Czy na pewno chcesz przywrócić?',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Anuluj',
                action: 'CLOSE'
            },
            {
                text: 'Przywróć',
                action: 'PUBLISHED'
            },
        ]
    },
    terror_action: {
        type: 'dsa_modal',
        header: 'Terror',
        text: 'Czy na pewno treść ma zostać usunięta i oznaczona jako terrorystyczna?',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Anuluj',
                action: 'CLOSE'
            },
            {
                text: 'Potwierdzam',
                action: 'TERROR'
            },
        ]
    },
    no_terror_action: {
        type: 'dsa_modal',
        header: 'Przywróć terror',
        text: 'Czy na pewno treść ma zostać przywrócona i nie będzie oznaczona jako terrorystyczna?',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Anuluj',
                action: 'CLOSE'
            },
            {
                text: 'Potwierdzam',
                action: 'NO_TERROR'
            },
        ]
    },
    one_input_text: {
        type: 'dsa_modal',
        header: 'Przykładowy modal z inputem textowym',
        text: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec suscipit auctor dui,',
        extraText: 'Dodatkowy text',
        extraClass: '',
        inputs: [
            {
                type: 'text',
                name: 'one_input_text',
                placeholderText: 'Napisz tutaj',
                label: 'Powody dla których uważasz, że decyzja jest niesłuszna i powinna zostać zmieniona',
                required: true,
                actionType: 'input',
                actionMethod: 'TEXT_INPUT_ACTION',
                helperText: '',
                extraCss: '',
            }
        ],
        buttons: [
            {
                text: 'Anuluj',
                action: 'CLOSE'
            },
            {
                text: 'Zatwierdź',
                action: 'TEST_ACTION'
            },
        ]
    },
    comment_already_deleted: {
        type: 'dsa_modal',
        header: 'Komentarz jest usunięty',
        text: 'Komentarz, który próbujesz zgłosić, został już usunięty.',
        extraText: '',
        extraClass: '',
        inputs: [],
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    tresc_usunieta: {
        type: 'dsa_modal',
        header: 'Komentarz usunięty',
        text: 'Twój komentarz został automatycznie usunięty przez system moderacji, ponieważ narusza regulamin.',
        extraText: '',
        extraClass: '',
        buttons: [
            { text: 'Wróć do artykułu', action: 'BACK' },
        ],
    },
    tresc_ukryta: {
        type: 'dsa_modal',
        header: 'Komentarz opublikowany',
        text: 'Twój komentarz został opublikowany, ale część treści została automatycznie ukryta.',
        extraText: '',
        extraClass: '',
        buttons: [
            { text: 'Rozumiem', action: 'BACK' },
        ],
    },
};


const complaintModalsForum: ModalConfig = {
    complaint_form: {
        type: 'dsa_modal',
        header: 'Skarga na decyzję',
        text: 'Aby złożyć skargę na decyzję dotyczącą zgłoszonych przez Ciebie treści lub treści usuniętych, których jesteś autorem uzupełnij poniższy formularz w terminie nie dłuższym niż 6 miesięcy od powiadomienia o decyzji.',
        extraText: '',
        extraClass: '',
        inputs: [
            {
                type: 'textarea',
                name: 'complaint_reason',
                placeholderText: 'Napisz tutaj',
                label: 'Powody dla których uważasz, że decyzja jest niesłuszna i powinna zostać zmieniona',
                required: true,
                actionType: 'input',
                actionMethod: 'checkText',
                helperText: '',
                extraCss: 'dsaModal__input--textarea',
            }
        ],
        buttons: [
            {
                text: 'Anuluj',
                action: 'CLOSE'
            },
            {
                text: 'Wyślij',
                action: 'SEND_COMPLAINT'
            },
        ]
    },
    complaint_expired: {
        type: 'dsa_modal',
        header: 'Czas na wniesienie skargi upłynął',
        text: 'Skargę wnosi się w terminie 6 miesięcy od momentu powiadomienia.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    complaint_thankYou: {
        type: 'dsa_modal',
        header: 'Dziękujemy',
        text: 'Twoja skarga już do nas dotarła.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
    complaint_confirmed: {
        type: 'dsa_modal',
        header: 'Skarga została już zgłoszona',
        text: 'Otrzymasz informację po rozpatrzeniu skargi.',
        extraText: '',
        extraClass: '',
        buttons: [
            {
                text: 'Wróć do artykułu',
                action: 'BACK'
            },
        ]
    },
};

const censurexModalsForum: ModalConfig = {
    tresc_usunieta: {
        ...defaultConfig.tresc_usunieta,
        buttons: [
            { text: 'Wróć do forum', action: 'BACK' },
        ],
    },
    tresc_ukryta: {
        ...defaultConfig.tresc_ukryta,
        buttons: [
            { text: 'Rozumiem', action: 'BACK' },
        ],
    },
};


export const allModals = {
    gazeta_pl: defaultConfig,
    wyborcza: defaultConfig,
    forum: { ...defaultConfig, ...complaintModalsForum, ...censurexModalsForum },
}

export type AllModalsVariantType = keyof typeof allModalsVariant;

export const allModalsVariant = generateAllModalsVariant(defaultConfig);

function generateAllModalsVariant(config: typeof defaultConfig) {
    const variant: Record<string, string> = {};

    for (const key in config) {
        if (config.hasOwnProperty(key)) {
            variant[key] = config[key as keyof typeof defaultConfig].type;
        }
    }

    //tymczasowo do momenty połączenia modali z formularzem akcji i formularzem zgłoś
    variant['delete_action'] = 'dsa_action';
    variant['censor_action'] = 'dsa_action';
    variant['delete_author_action'] = 'dsa_action';
    variant['report_form'] = 'dsa_form';
    
    return variant;
}